import { useAuthUser } from '@/hooks/useAuthUser';
import { useOrganization } from '@/hooks/useOrganization';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AccountLoadFailed, AuthPending, RedirectToLogin } from './ProtectedRoute';
import { useArrivalReturnPath } from '@/hooks/useArrivalReturnPath';

interface SuperuserProtectedRouteProps {
  element: React.ReactElement;
}

/** Gates routes to admin OR superuser plans. Used for the Marketplace R&D
 *  spike so internal team accounts (typically `superuser`) can access it
 *  while keeping the route hidden from regular users. */
export const SuperuserProtectedRoute = ({ element }: SuperuserProtectedRouteProps) => {
  const { user, loading: authLoading } = useAuthUser();
  const { subscriptionPlan, loading: orgLoading, error: orgError, refresh } = useOrganization();
  const location = useLocation();
  const returnTo = useArrivalReturnPath(!!user);

  const isStaff = subscriptionPlan === 'admin' || subscriptionPlan === 'superuser';

  if (authLoading || orgLoading) return <AuthPending />;
  if (!user) return <RedirectToLogin search={location.search} returnTo={returnTo} />;
  if (!subscriptionPlan && orgError) return <AccountLoadFailed onRetry={() => void refresh()} />;
  if (!isStaff) return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />;

  return element;
};
